/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const fileUpload = require('vue-upload-component');
const dataPicker = require('components/common/data-picker/data-picker');
const checkbox = require('components/base/checkbox/checkbox');
const dropMenu = require('components/base/drop-menu/drop-menu');
const formArea = require('components/base/form-area/form-area');
const upload = require('components/base/upload/upload');
const tip = require('components/base/pop/tip');

require('appUtil/ajaxSetting');
const ajaxHttp = require('appUtil/ajaxHttp');
const store = require('appVuex/store');

const {	setBreadCrumb } = require('src/common/vuex/action/common');
const {	apiPath } = require('appService/api');
const { checkbox: checkboxEvent, dropMenu: dropMenuEvent } = require('components/config/event.json');

require('src/common/lib/jquery.timepicker/index.css');
require('src/common/lib/jquery.timepicker/index.js');

const template = require('./site-comment.tpl');
require('./site-comment.scss');

const siteComment = {
  template,
  store,
  vuex: {
    actions: {
      setBreadCrumb,
    }
  },
  data() {
    return {
      uploadImgUrl: apiPath.common.uploadImg,
      publishUrl:  apiPath.charge.comment,
      recTopicUrl:  apiPath.charge.recommendTopic,
      getVestUrl: apiPath.common.getVest,
      // getVestUrl: "http://devel.admin.evclub.com/common/getVestAccount",

      queryTime: "",
      gradeItem: [
	    	{value: "5", text: "5分"},
	    	{value: "4", text: "4分"},
	    	{value: "3", text: "3分"},
	    	{value: "2", text: "2分"},
				{value: "1", text: "1分"}
	    ],
	    checkboxItems: [
	    	{"text": "设置为当前时间", "value": 1}
	    ],
      userItem: [
        {value: "-1", text: "选择马甲账号作为署名"},
      ],
	    grade: {
	    	"totalGrade": 5,
	    	"priGrade": 5,
	    	"envGrade": 5,
	    	"serGrade": 5
	    },
	    comment: "",

	    imageArr: [],
	    hours: "",
	    minutes: "",
	    submitObj: {},
	    spotID: "",
	    userName: "",
      userId: null,
      topicValue: null
    }
  },
  ready() {
    this.initTime(); 

    this.spotID = this.$route.query.spotID;
    this.userName = this.$route.query.userName;

    // this.getRecommendTopic();  //获取推荐话题
    this.getVestData();  //获取马甲账号
    this.DOMEventBinding();
  },
  methods: {
    initTime() {
      $("#hours").timepicker({
        'timeFormat': 'H',
        minTime: '0',
	    	maxTime: '23',
	    	step: 60
      });

      $("#minutes").timepicker({
        'timeFormat': 'i',
	    	step: 1
      })
    },
		formatTime(time, type) {
		  let dTime = new Date(time),
		  		dMinutes = dTime.getMinutes();
					dMinutes = dMinutes< 10 ? "0"+ dMinutes : dMinutes;

		  switch(type) {
				case "time":
				  return `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}`;
				  break;
				case "hour":
				  return `${dTime.getHours()}`
				  break;
				case "minute":
				  return `${dMinutes}`
				  break;
		  }
		}, 
		serializeObj: function(args){
		  let serialStr = '';
		  for(let key in args){
				if (typeof args[key] == "object"){
				  let arr = args[key];
				  for (let i of arr){
						serialStr += `&${key}=${i}`;
				  }
				} else {
				  serialStr += `&${key}=${args[key]}`;
				}
		  }
		  return serialStr.substring(1);
		},
		goBack() {
		  this.$route.router.go({
	      path:"/page/charge/siteLists/detail",
	      query: {"spotID": this.spotID}
	    });
		},
		publish() {
		  let uploadItems = this.$refs.upload.uploadItems;
			this.imageArr  = uploadItems;

      this.comment = this.$refs.commenttxt.value;

		  this.submitObj = Object.assign({}, this.submitObj, {
		    "spotId" : this.spotID,
		    "gradeInfo": this.grade["totalGrade"],
		    "priceGrade": this.grade["priGrade"],
		    "environmentGrade": this.grade["envGrade"],
		    "serveGrade": this.grade["serGrade"],
		    "comment": this.comment,
		    "userId": `${this.userId}` == -1 ? null : `${this.userId}`,
		    "pictures": this.imageArr,
		    "commentTime": `${this.queryTime}` ? `${this.queryTime} ${this.hours}:${this.minutes}` : null
		  })

      if (this.verify()){

        ajaxHttp(this.publishUrl, {
          type: "POST",
          data: this.submitObj
        }).then((res) => {
          tip("评论发表成功");

          this.$route.router.go({
            path:"/page/charge/siteLists/detail",
            query: {"spotID": this.spotID}
          });
        }).catch((res) => {
          tip(res.messsage);
        });
      }
		},
    verify() {
      if (!this.comment || this.comment.length <= 10){
        tip("评论内容少于10字");
        
        $(".textarea-stage .input-box-wrap").css("border-color", "#ff8888")
        return false;
      }
      if (this.userId == "-1" || !this.userId){
        tip("请选择马甲账号");
        return false;
      }
      // if (this.imageArr.length < 1){
      //   tip("至少上传1张照片");
      //   return false;
      // }
      if (!this.queryTime){
        tip("请选择发布时间");
        return false;
      }
      if (!this.hours){
        tip("请选择小时");
        return false;
      }
      if (!this.minutes){
        tip("请选择分钟");
        return false;
      }
      return true
    },
    DOMEventBinding() {
      $(".textarea-stage textarea").focus(function(){
        $(".textarea-stage .input-box-wrap").css("border-color","#d6d6d6")
      });
    },
    getRecommendTopic() {
      ajaxHttp(this.recTopicUrl, {
        "type": "post",
        "data": {"spotId" : this.spotID}
      }).then((res) => {
        
        if (res.code == 0){
          this.topicValue = this.recommendTopic(res.data.topicType);
        }
      }).catch((res) => {
      // tip(res.messsage);
      });
    },
    recommendTopic(val) {
      let topic = {
        "0": "#充电点特斯拉# ",
        "1": "#充电点国标# ",
        "2": "#充电点全部# "
      }
      return topic[val]
    },
    getVestData() {
      ajaxHttp(this.getVestUrl, {})
      .then((res) => {

        for (let i of res.data){
          let obj = {};
          obj.value = i.id;
          obj.text = i.nickName;
          this.userItem.push(obj);
        }
      }).catch((res) => {
      // tip(res.messsage);
      });
    }
  },
  events:{
    [checkboxEvent.change](val) {
		  if (this.$refs.timeCheckbox.value[0] === this.checkboxItems[0].value){
		    let now = new Date();

		    this.queryTime = this.formatTime(now, "time");
		    this.hours = this.formatTime(now, "hour");
		    this.minutes = this.formatTime(now, "minute")
		  } else {
		    this.queryTime = "";
				this.hours = "";
				this.minutes = "";
		  }
		},
		[dropMenuEvent.menu.change](val) {
		  let name = val.dispatcher.queryName;
		  let value = parseInt(val.optionItem.value);
		  
      if (name == "userId"){
        this.userId = value;
      } else {
        this.grade[name] = value;  //下拉更新评分值
      }
		}
  },
  components: {
		fileUpload,
		dataPicker,
		checkbox,
		upload,
		dropMenu
  },
  watch: {
		"hours":function(val,oldVal) {
		  // console.log(this.$refs.dataPicker.value)
		}
  }
}

module.exports = siteComment;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/charge/site-comment/site-comment.js